import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { createStore, StoreProvider, useStoreActions } from 'easy-peasy';
import 'bootstrap/dist/css/bootstrap.css';
import '../../scss/app.scss';
import { AmplifyAuthContainer, AmplifyAuthenticator, AmplifySignIn } from '@aws-amplify/ui-react';
import { Amplify } from 'aws-amplify';
import { AuthState, onAuthUIStateChange } from '@aws-amplify/ui-components';
import { Provider } from 'react-redux';
import Router from './Router';
import awsconfig from '../../aws-exports';
import model from '../../model/model';

Amplify.configure(awsconfig);

const store = createStore(model);

const App = () => {
  const [authState, setAuthState] = React.useState();
  const [user, setUser] = React.useState();
  const [isAdmin, setIsAdmin] = React.useState(false);
  const [isVisitor, setIsVisitor] = React.useState(false);
  const [clientId, setClientId] = React.useState();
  const [promotionId, setPromotionId] = React.useState();

  React.useEffect(() => onAuthUIStateChange((nextAuthState, authData) => {
    if (authData === undefined || authData.attributes === undefined) {
      return;
    }
    const { email } = authData.attributes;
    if (email.indexOf('inmocaixa.sevilla91.visitas@bizionar.net') !== -1) {
      setClientId('inmocaixa');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('nervion-zenit');
    } else if (email.indexOf('inmocaixa.sevilla32.visitas@bizionar.net') !== -1) {
      setClientId('inmocaixa');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('sevilla-32');
    } else if (email.indexOf('culmia.rubi-futur.visitas@bizionar.net') !== -1) {
      setClientId('culmia');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('rubi-futur');
    } else if (email.indexOf('culmia.mistral.visitas@bizionar.net') !== -1) {
      setClientId('culmia');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('mistral');
    } else if (email.indexOf('culmia.xaloc.visitas@bizionar.net') !== -1) {
      setClientId('culmia');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('xaloc');
    } else if (email.indexOf('culmia.portonovo.visitas@bizionar.net') !== -1) {
      setClientId('culmia');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('portonovo');
    } else if (email.indexOf('culmia.port-montjuic.visitas@bizionar.net') !== -1) {
      setClientId('culmia');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('port-montjuic');
    } else if (email.indexOf('culmia.mijas.visitas@bizionar.net') !== -1) {
      setClientId('culmia');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('mijas');
    } else if (email.indexOf('culmia.forti.visitas@bizionar.net') !== -1) {
      setClientId('culmia');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('el-forti-de-denia');
    } else if (email.indexOf('culmia.azahara.visitas@bizionar.net') !== -1) {
      setClientId('culmia');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('azahara-poniente');
    } else if (email.indexOf('culmia.insider.visitas@bizionar.net') !== -1) {
      setClientId('culmia');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('insider');
    } else if (email.indexOf('culmia.augusta.visitas@bizionar.net') !== -1) {
      setClientId('culmia');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('augusta-volpelleres');
    } else if (email.indexOf('culmia.font-volpelleres.visitas@bizionar.net') !== -1) {
      setClientId('culmia');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('la-font-de-volpelleres');
    } else if (email.indexOf('culmia.parctextil.visitas@bizionar.net') !== -1) {
      setClientId('culmia');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('parc-textil');
    } else if (email.indexOf('culmia.themis.visitas@bizionar.net') !== -1) {
      setClientId('culmia');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('themis-riera');
    } else if (email.indexOf('culmia.maestral.visitas@bizionar.net') !== -1) {
      setClientId('culmia');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('maestral-rocafort');
    } else if (email.indexOf('culmia.essencia.visitas@bizionar.net') !== -1) {
      setClientId('culmia');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('essencia-sarria');
    } else if (email.indexOf('culmia.placa-vila.visitas@bizionar.net') !== -1) {
      setClientId('culmia');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('placa-de-la-vila');
    } else if (email.indexOf('culmia.mardecalonge@bizionar.net') !== -1) {
      setClientId('culmia');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('mar-de-calonge');
    } else if (email.indexOf('culmia.canmare.visitas@bizionar.net') !== -1) {
      setClientId('culmia');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('can-mare');
    } else if (email.indexOf('culmia.arbeyal.visitas@bizionar.net') !== -1) {
      setClientId('culmia');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('arbeyal-ii-gijon');
    } else if (email.indexOf('culmia.arbeyal4.visitas@bizionar.net') !== -1) {
      setClientId('culmia');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('arbeyal-iv-gijon');
    } else if (email.indexOf('culmia.laroca.visitas@bizionar.net') !== -1) {
      setClientId('culmia');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('la-roca-natura');
    } else if (email.indexOf('culmia.sedna.visitas@bizionar.net') !== -1) {
      setClientId('culmia');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('retamar-sedna');
    } else if (email.indexOf('culmia.isthar.visitas@bizionar.net') !== -1) {
      setClientId('culmia');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('retamar-isthar');
    } else if (email.indexOf('culmia.bastet.visitas@bizionar.net') !== -1) {
      setClientId('culmia');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('retamar-bastet');
    } else if (email.indexOf('culmia.milda.visitas@bizionar.net') !== -1) {
      setClientId('culmia');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('retamar-milda');
    } else if (email.indexOf('culmia.bes.visitas@bizionar.net') !== -1) {
      setClientId('culmia');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('retamar-bes');
    } else if (email.indexOf('culmia.lono.visitas@bizionar.net') !== -1) {
      setClientId('culmia');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('retamar-lonos');
    } else if (email.indexOf('culmia.eterna.visitas@bizionar.net') !== -1) {
      setClientId('culmia');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('eterna-michelena');
    } else if (email.indexOf('culmia.autum.visitas@bizionar.net') !== -1) {
      setClientId('culmia');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('retamar-autum');
    } else if (email.indexOf('culmia.balder.visitas@bizionar.net') !== -1) {
      setClientId('culmia');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('retamar-balder');
    } else if (email.indexOf('culmia.mitra.visitas@bizionar.net') !== -1) {
      setClientId('culmia');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('retamar-mitra');
    } else if (email.indexOf('culmia.eros.visitas@bizionar.net') !== -1) {
      setClientId('culmia');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('retamar-eros');
    } else if (email.indexOf('culmia.costagaleraiii.visitas@bizionar.net') !== -1) {
      setClientId('culmia');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('costa-galera-iii');
    } else if (email.indexOf('culmia.marcelona.visitas@bizionar.net') !== -1) {
      setClientId('culmia');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('marcelona');
    } else if (email.indexOf('mvc.gasometro.visitas@bizionar.net') !== -1) {
      setClientId('metrovacesa');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('gasometro');
    } else if (email.indexOf('mvc.llotjalleida.visitas@bizionar.net') !== -1) {
      setClientId('metrovacesa');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('la-llotja-de-lleida');
    } else if (email.indexOf('mvc.alemanya60.visitas@bizionar.net') !== -1) {
      setClientId('metrovacesa');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('alemanya-60');
    } else if (email.indexOf('ebrosa.airbox.visitas@bizionar.net') !== -1) {
      setClientId('ebrosa');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('air-box-valdebebas');
    } else if (email.indexOf('ebrosa.iconiq.visitas@bizionar.net') !== -1) {
      setClientId('ebrosa');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('iconiq');
    } else if (email.indexOf('@culmia.com') !== -1) {
      setClientId('culmia');
      setIsAdmin(false);
    } else if (email.indexOf('azul.alcaidesa.visitas@bizionar.net') !== -1) {
      setClientId('azul-real-estate');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('alcaidesa-homes');
    } else if (email.indexOf('@azuldevelopments.com') !== -1) {
      setClientId('azul-real-estate');
      setIsAdmin(false);
    } else if (email.indexOf('@metrovacesa.com') !== -1) {
      setClientId('metrovacesa');
      setIsAdmin(false);
    } else if (email.indexOf('@inmocaixa.com') !== -1) {
      setClientId('inmocaixa');
      setIsAdmin(false);
    } else if (email.indexOf('@ebrosa.com') !== -1) {
      setClientId('ebrosa');
      setIsAdmin(false);
    } else if (email.indexOf('@reina.org') !== -1) {
      setClientId('reina');
      setIsAdmin(false);
    } else if (email.indexOf('@arquinex.es') !== -1) {
      setClientId('erro-y-eugui');
      setIsAdmin(false);
    } else if (email.indexOf('@erroyeugui.com') !== -1) {
      setClientId('erro-y-eugui');
      setIsAdmin(false);
    } else if (email.indexOf('@viacelere.es') !== -1) {
      setClientId('via-celere');
      setIsAdmin(false);
    } else if (email.indexOf('@lallavedeoro.com') !== -1) {
      setClientId('la-llave-de-oro');
      setIsAdmin(false);
    } else if (email.indexOf('lallave.alcala.visitas@bizionar.net') !== -1) {
      setClientId('la-llave-de-oro');
      setIsAdmin(false);
      setIsVisitor(true);
      setPromotionId('alcala-de-henares');
    } else if (email.indexOf('@bizionar.net') !== -1) {
      setClientId('bizionar');
      setIsAdmin(true);
    } else {
      switch (email) {
        case 'josep.ma.vidal@gmail.com':
          setClientId('bizionar');
          setIsAdmin(true);
          break;
        case 'AMartinez@hirealestate.es':
          setClientId('hi-real-estate');
          setIsAdmin(false);
          break;
        default:
          setClientId('culmia');
          setIsAdmin(false);
          break;
      }
    }

    setAuthState(nextAuthState);
    setUser(authData);
  }), []);

  return authState === AuthState.SignedIn && clientId !== undefined && user ? (
    <Provider store={store}>
      <StoreProvider store={store}>
        <BrowserRouter>
          <Router isAdmin={isAdmin} clientId={clientId} isVisitor={isVisitor} promotionId={promotionId} />
        </BrowserRouter>
      </StoreProvider>
    </Provider>
    ) : (
      <AmplifyAuthContainer>
        <AmplifyAuthenticator>
          <AmplifySignIn
            slot="sign-in"
            headerText="Accede a digitalGRID"
            hideSignUp
            submitButtonText="LOGIN"
          />
        </AmplifyAuthenticator>
      </AmplifyAuthContainer>
    );
};

export default App;
